import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
export function About() {
  return <section id="about" className="py-24 md:py-32" data-id="element-14">
      <div className="container mx-auto px-6 md:px-12" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-16">
          <SectionReveal data-id="element-17">
            <h2 className="font-serif text-4xl md:text-5xl mb-8" data-id="element-18">
              The short version.
            </h2>
            <div className="space-y-6 text-lg text-secondary leading-relaxed" data-id="element-19">
              <p data-id="element-20">
                I'm Alex — Co-founder and CEO of{' '}
                <span className="text-primary font-medium" data-id="element-21">Waydev</span>, a Y
                Combinator <span className="text-primary" data-id="element-22">(W21)</span> backed
                engineering analytics platform used by teams at Amex,
                Caterpillar, Dropbox, BlueCross BlueShield, PwC, Aon, and a few
                hundred others you've probably heard of.
              </p>
              <p data-id="element-23">
                I'm also a member of the{' '}
                <span className="text-primary" data-id="element-24">Forbes Tech Council</span> and a
                contributing writer for{' '}
                <span className="text-primary" data-id="element-25">Forbes</span>,{' '}
                <span className="text-primary" data-id="element-26">TechCrunch</span>,{' '}
                <span className="text-primary" data-id="element-27">Fortune</span>, and{' '}
                <span className="text-primary" data-id="element-28">Entrepreneur</span> — which
                basically means I've spent years figuring out what editors
                actually open, and what gets ignored.
              </p>
              <p data-id="element-29">
                Under my leadership Waydev became a{' '}
                <span className="text-primary" data-id="element-30">G2 Leader</span> in its category
                and earned recognition from{' '}
                <span className="text-primary" data-id="element-31">Gartner</span> — so I know
                first-hand how to play the analyst & review-site game without
                burning cash on a $250k/yr AR firm.
              </p>
              <p data-id="element-32">
                Having raised multiple rounds, scaled Waydev to serve Fortune
                500 enterprises, and analyzed the operational data of over 500
                engineering organizations, I provide strategic counsel rooted in
                empirical data and executive experience.
              </p>
              <p className="text-base text-muted italic border-l-2 border-accent/40 pl-4" data-id="element-33">
                Strategic advisory from an operator who has successfully
                navigated the complexities of scaling enterprise engineering
                organizations.
              </p>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.2} data-id="element-34">
            <div className="bg-surface rounded-3xl p-8 md:p-12 border border-border" data-id="element-35">
              <h3 className="text-xl font-medium mb-8 border-b border-border pb-4" data-id="element-36">
                Receipts & Credentials
              </h3>

              <div className="grid grid-cols-2 gap-6 mb-10" data-id="element-37">
                <div data-id="element-38">
                  <div className="font-serif text-4xl text-primary mb-2" data-id="element-39">
                    500+
                  </div>
                  <p className="text-xs text-secondary uppercase tracking-wider" data-id="element-40">
                    Eng teams analyzed at Waydev
                  </p>
                </div>

                <div data-id="element-41">
                  <div className="font-serif text-4xl text-primary mb-2" data-id="element-42">6</div>
                  <p className="text-xs text-secondary uppercase tracking-wider" data-id="element-43">
                    Fortune 500 customers
                  </p>
                </div>

                <div data-id="element-44">
                  <div className="font-serif text-4xl text-primary mb-2" data-id="element-45">4</div>
                  <p className="text-xs text-secondary uppercase tracking-wider" data-id="element-46">
                    Major media outlets writing for
                  </p>
                </div>

                <div data-id="element-47">
                  <div className="font-serif text-4xl text-primary mb-2" data-id="element-48">
                    10+
                  </div>
                  <p className="text-xs text-secondary uppercase tracking-wider" data-id="element-49">
                    Years building dev tools
                  </p>
                </div>
              </div>

              <div className="pt-6 border-t border-border" data-id="element-50">
                <p className="text-sm text-muted mb-5 uppercase tracking-wider font-medium" data-id="element-51">
                  Selected Milestones
                </p>
                <ul className="space-y-4" data-id="element-52">
                  <li className="flex items-center gap-3" data-id="element-53">
                    <span className="w-8 h-8 rounded bg-base flex items-center justify-center text-accent font-serif font-bold text-sm shrink-0" data-id="element-54">
                      Y
                    </span>
                    <span className="text-secondary text-sm" data-id="element-55">
                      Y Combinator W21
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-56">
                    <span className="w-8 h-8 rounded bg-base flex items-center justify-center text-accent font-serif font-bold text-sm shrink-0" data-id="element-57">
                      F
                    </span>
                    <span className="text-secondary text-sm" data-id="element-58">
                      Forbes Tech Council Member
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-59">
                    <span className="w-8 h-8 rounded bg-base flex items-center justify-center text-accent font-serif font-bold text-sm shrink-0" data-id="element-60">
                      ✍
                    </span>
                    <span className="text-secondary text-sm" data-id="element-61">
                      Contributor: TechCrunch, Forbes, Fortune, Entrepreneur
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-62">
                    <span className="w-8 h-8 rounded bg-base flex items-center justify-center text-accent font-serif font-bold text-sm shrink-0" data-id="element-63">
                      $
                    </span>
                    <span className="text-secondary text-sm" data-id="element-64">
                      Raised multiple rounds for Waydev
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-65">
                    <span className="w-8 h-8 rounded bg-base flex items-center justify-center text-accent font-serif font-bold text-sm shrink-0" data-id="element-66">
                      G
                    </span>
                    <span className="text-secondary text-sm" data-id="element-67">
                      G2 Leader & Gartner-recognized vendor
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-68">
                    <span className="w-8 h-8 rounded bg-base flex items-center justify-center text-accent font-serif font-bold text-sm shrink-0" data-id="element-69">
                      S
                    </span>
                    <span className="text-secondary text-sm" data-id="element-70">
                      Speaker at SaaStr & Web Summit
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>;
}